module.exports = __webpack_public_path__ + "static/media/send-icon.d2d7a28d.svg";